export const getTags = (
	currTags: Set<string>,
	newTags: Set<string>,
	ignoreCurrTags?: boolean
) => {
	if (ignoreCurrTags) return newTags;
	return new Set([...currTags, ...newTags]);
};
